import type { InvoiceDataSchemaType } from '@/components/steps/InvoicingStep/invoiceDataSchema';
import SummaryStepSection from '@/components/steps/SummaryStep/SummaryStepSection';
import { useCountryNames } from '@/hooks/useCountryNames';
import { addressBuilder, t } from '@/lib/utils';

export type SummaryStepCompanySectionProps = {
    goToPage: (stepNumber: number) => void;
    invoicingDataState: InvoiceDataSchemaType;
};

export const SummaryStepCompanySection = ({ invoicingDataState, goToPage }: SummaryStepCompanySectionProps) => {
    const companyCountryWithFlag = useCountryNames()?.find(
        item => item.id === invoicingDataState?.company.country
    )?.label;
    return (
        <SummaryStepSection title={t('onboarding.companyData')} goToFunction={() => goToPage(1)}>
            <div className='padding-bottom-5'>
                {`${t('general.companyName')}: `}
                <strong>{invoicingDataState.company.customerName}</strong>
            </div>
            <div className='padding-bottom-5'>
                {`${t('general.address')}: `}
                <strong>
                    {addressBuilder(
                        `${invoicingDataState.company.address} ${invoicingDataState.company.address2}`.trim(),
                        invoicingDataState.company.postCode,
                        invoicingDataState.company.city,
                        companyCountryWithFlag ?? ''
                    )}
                </strong>
            </div>
            {invoicingDataState.company.companyRegistrationNumber && (
                <div className='padding-bottom-5'>
                    {`${t('general.companyRegistrationNumber')}: `}
                    <strong>{invoicingDataState.company.companyRegistrationNumber}</strong>
                </div>
            )}
        </SummaryStepSection>
    );
};
